<template>
  <div class="product-page">
    <div class="product-panel">
      <div class="linear-background">
        <img :src="backgroundImg" />
        <div class="title">
          <h2>法律科研创新，AI 赋能</h2>
          <p class="word-middle">我们致力于支持更多人实现法律深度研究的学术梦想，让法律数据实证分析变得简单可行。</p>
        </div>
      </div>

      <div class="type-panel">
        <div class="type-item">
          <div
            :style="{
              borderBottom: '1px solid #D2D8E3',
              minHeight: '230px'
            }"
          >
            <h4>试用版课题</h4>
            <p>适用于产品的简单体验</p>
            <h4>免费</h4>
            <div class="button" :style="{ color: '#77839E', border: '1px solid #D2D8E3' }">使用中</div>
          </div>
          <div class="usage word-normal">
            <div class="usage-title">功能包括：</div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">课题数：2个课题</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">课题有效期：3个月</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">课题数据集500条</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持使用平台预设数据维度</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持自定义数据维度</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据清洗</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据验证</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据统计分析的基础模型</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持全套的可视化图表</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持下载实证分析报告</span>
            </div>
          </div>
        </div>
        <div class="type-item">
          <div
            :style="{
              borderBottom: '1px solid #D2D8E3',
              minHeight: '230px'
            }"
          >
            <h4>专业版课题</h4>
            <p>适用于个人研究使用</p>
            <div class="price">
              <span>￥</span>
              <b>59</b>
              <a class="word-smaller">元起</a>
            </div>
            <!-- <div class="original-price">
              <span>原价：￥3999</span>
            </div> -->
            <div class="button" @click="showWechat = true" :style="{ color: '#1991FB', border: '1px solid #1991FB' }">
              <span class="icon-small">
                <img :src="wechatImg" />
              </span>
              联系顾问
            </div>
            <!-- <a class="show word-normal" @click="showWechat = true">预约演示 > </a> -->
          </div>
          <div class="usage word-normal">
            <div class="usage-title">功能包括：</div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">亿级全量库最新数据，实时更新</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持使用平台预设数据维度</span>
            </div>

            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持自定义数据维度</span>
            </div>

            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据清洗</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据验证</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据统计分析的基础模型</span>
            </div>

            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据高级模型（多元线性回归）</span>
            </div>

            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持全套的可视化图表</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持下载实证分析报告</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持多人协作（即将推出）</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">提供专属客服服务</span>
            </div>

            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">课题有效期一年</span>
            </div>
          </div>
        </div>
        <div class="type-item">
          <div
            :style="{
              borderBottom: '1px solid #D2D8E3',
              minHeight: '230px'
            }"
          >
            <h4>机构版套餐</h4>
            <p>适用于机构用户使用</p>
            <h4>详情咨询顾问</h4>
            <div class="button" @click="showWechat = true" :style="{ color: '#1991FB', border: '1px solid #1991FB' }">
              <span class="icon-small">
                <img :src="wechatImg" />
              </span>
              联系顾问
            </div>
          </div>
          <div class="usage word-normal">
            <div class="usage-title">功能包括：</div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">亿级全量库最新数据，实时更新</span>
            </div>

            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">1个账号3个课题，课题数据集50000条</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">数据高级模型（多元线性回归）</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持使用平台预设数据维度</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持自定义数据维度</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据清洗</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据验证</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持数据统计分析的基础模型</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持全套的可视化图表</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持下载实证分析报告</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持一键导出校验后数据</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持接入用户自有数据（即将推出）</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">支持多人协作（即将推出）</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">提供专属客服服务</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">提供在线使用指导课程</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">赠送实证分析的名家讲坛在线课程</span>
            </div>
            <div class="usage-item">
              <span class="icon-mini"><img :src="getImg" alt=""/></span>
              <span class="usage-text">课题有效期一年</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <custom-service :show.sync="showWechat" />
  </div>
</template>

<script>
import customService from '@/components/customService';

import backgroundImg from '@/assets/img/product-background.png';
import getImg from '@/assets/img/get.png';
import wechatImg from '@/assets/img/wechat-blue.png';

export default {
  components: { customService },
  data() {
    return {
      backgroundImg,
      getImg,
      wechatImg,
      showWechat: false
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.product-panel {
  padding-bottom: 84px;
  .linear-background {
    width: 100%;
    height: 500px;
    position: relative;
    background: linear-gradient(180deg, #0c93f2 0%, rgba(95, 184, 246, 0.66) 65%, #ffffff 100%);
    img {
      display: block;
      width: 100%;
    }
    .title {
      position: absolute;
      width: 100%;
      top: 75px;
      color: #fff;
      text-align: center;
      h2 {
        font-size: 44px;
        line-height: 62px;
      }
      p {
        margin-top: 10px;
      }
    }
  }

  .type-panel {
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    width: 1060px;
    margin: -240px auto 0 auto;
    z-index: 99;
    position: relative;

    &.tow-item {
      padding: 0 100px;
    }
    .type-item {
      width: 320px;
      min-height: 850px;
      background: #ffffff;
      box-shadow: 2px 6px 16px 2px rgba(131, 149, 173, 0.2);
      h4 {
        color: #001529;
        font-size: 24px;
        font-weight: 400;
        text-align: center;
        margin-top: 40px;
      }
      p {
        color: #9599a5;
        text-align: center;
        margin: 10px 0 0 0;
        font-size: 14px;
      }
      .button {
        width: 140px;
        line-height: 40px;
        text-align: center;
        margin: 30px auto 0 auto;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;

        &.buy-button {
          margin-top: 9px;
        }
      }
      .original-price {
        text-decoration: line-through;
        font-size: 12px;
        color: rgba(#001529, 0.3);
        text-align: center;
        margin-top: 10px;
      }
      .price {
        text-align: center;
        margin-top: 20px;
        span {
          color: #f62733;
          font-size: 24px;
        }
        b {
          color: #f62733;
          font-size: 45px;
        }
        a {
          color: #001529;
        }
      }
      .usage {
        padding: 0 30px;
        &-title {
          padding: 20px 0;
          color: #77839e;
        }
        &-item {
          display: flex;
          align-items: flex-start;
          padding-bottom: 18px;
          color: #2c3443;
          .icon-mini {
            position: relative;
            top: 2px;
            width: 14px;
            margin-right: 14px;

            & > img {
              width: 14px;
            }
          }

          & > a {
            color: #1991fb;
          }

          .usage-text {
            line-height: 17px;
            font-size: 14px;
            display: inline-block;
            flex: 1;
            width: 0;
          }
        }
      }
      .show {
        display: block;
        text-align: center;
        margin-top: 15px;
        color: #1991fb;
        cursor: pointer;
      }
    }
  }
}
</style>
